// Single source of truth for the site launch moment.
// Used by Landing.vue (countdown target) and the achievements store (tracking gate).

// SWAP THESE

// export const LAUNCH_AT = new Date("2026-04-29T10:55:00Z").getTime();
export const LAUNCH_AT = new Date("2026-04-29T11:40:00Z").getTime(); // 7:40AM ET April 29

// Early-bird window closes 24h after launch — user must arrive on launch day.
export const LAUNCH_DAY_END = LAUNCH_AT + 24 * 60 * 60 * 1000;
